import './ConfirmationModal.scss';
import React, { FunctionComponent, memo } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'plume-ui';
import FormattedMessage from '../../utils/components/FormattedMessage';
import { useRecoilValue } from 'recoil';
import { confirmationModalAtom } from '../../state';
import { ModalStyles } from 'plume-ui/dist/components/Modal/Modal';

export type ConfirmationModalProps = {
  isOpen: boolean;
  onRequestClose: () => void;
  onConfirm: () => void;
};

const addStylesToModal = (current: ModalStyles) => ({
  ...current,
  root: `${current.root} PlumeUI__Modal ConfirmationModal`,
});

const addStylesToModalHeader = (current: any) => ({
  ...current,
  root: `${current.root} PlumeUI__ModalBody ConfirmationModal__header`,
});

const addStylesToModalSection = (current: any) => ({
  ...current,
  root: `${current.root} PlumeUI__ModalBody ConfirmationModal__section`,
});

const ConfirmationModal: FunctionComponent<ConfirmationModalProps> = (
  props,
) => {
  const confirmationModal = useRecoilValue(confirmationModalAtom);

  const onCancel = () => {
    props.onRequestClose();
  };

  const onConfirm = () => {
    props.onConfirm();
    props.onRequestClose();
  };

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={onCancel}
      classes={addStylesToModal}
    >
      <ModalHeader
        classes={addStylesToModalHeader}
        title={
          confirmationModal.title || (
            <FormattedMessage id="confirmation.title" />
          )
        }
      />
      <ModalBody classes={addStylesToModalSection}>
        {confirmationModal.body || <FormattedMessage id="confirmation.body" />}
      </ModalBody>
      <ModalFooter>
        <Button
          type="button"
          styleVariant="tertiary-grey"
          onClick={() => onCancel()}
        >
          {confirmationModal.cancelButtonLabel || (
            <FormattedMessage id="confirmation.cancel" />
          )}
        </Button>
        <Button
          styleVariant="superprimary"
          type="button"
          onClick={() => onConfirm()}
          classes={(current) => ({
            ...current,
            root: `${current.root} m-l-xs`,
          })}
        >
          {confirmationModal.confirmButtonLabel || (
            <FormattedMessage id="confirmation.confirm" />
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default memo(ConfirmationModal);
